import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import {PagedRequestDTO} from 'src/app/modules/common//models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from 'src/app/modules/common//models/PagedResponseDTO';
import {IngredientDTO} from 'src/app/modules/pbm/models/IngrdientDTO';

@Injectable({
  providedIn: 'root'
})
export class IngredientService {

  private url = environment.baseUrl + '/ingredient';

  constructor(private httpClient: HttpClient) {
  }

  getListOfIngredients(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<IngredientDTO>> {
    return this.httpClient.post<PagedResponseDTO<IngredientDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  saveIngredient(ingredientDTO: IngredientDTO): Observable<IngredientDTO> {
    return this.httpClient.post<IngredientDTO>(this.url, ingredientDTO);
  }

  deleteIngredient(ingredientId: number): Observable<{}> {
    return this.httpClient.delete<{}>(this.url + '/' + ingredientId);
  }

  getIngredient(ingredientId: number): Observable<IngredientDTO> {
    return this.httpClient.get<IngredientDTO>(this.url + '/' + ingredientId);
  }
}
